const Marquee = ({ items, reverse = false, dark = false }) => {
  const row = [...items, ...items, ...items];
  return (
    <div
      data-testid={reverse ? "marquee-reverse" : "marquee"}
      className={`relative overflow-hidden border-y py-5 ${
        dark ? "border-linen/10 bg-olive text-linen/60" : "border-ink/10 bg-sand text-forest/60"
      }`}
    >
      <div className={`marquee-track flex w-max items-center gap-10 ${reverse ? "marquee-reverse" : ""}`}>
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <span className="font-serif text-lg font-light italic tracking-wide sm:text-xl">{item}</span>
            <span className={`h-1.5 w-1.5 rounded-full ${dark ? "bg-gold/50" : "bg-terra/50"}`} />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
